import { type QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { useApi } from "@/core/api";
import type { PayrollStatementPackApprovalsResponse } from "@/payroll/pay-breakdown/payroll-statement-notifications/types";
import {
  payrollStatementNotificationsPath,
  payrollStatementPackApprovalsKey,
} from "./keys";

export const useGetPayrollStatementPackApprovals = (
  businessId: string | null,
  periodStart: string | null,
  enabled: boolean,
) => {
  const api = useApi();
  return useQuery({
    queryKey: payrollStatementPackApprovalsKey(businessId, periodStart),
    queryFn: ({ signal }: QueryFunctionContext) => {
      if (!businessId || !periodStart) {
        throw new Error("Pay period is required");
      }

      return api
        .get(
          `${payrollStatementNotificationsPath(businessId, periodStart)}/pack_approvals`,
          { signal },
        )
        .then((res) => res.data as PayrollStatementPackApprovalsResponse);
    },
    enabled: enabled && !!businessId && !!periodStart,
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchInterval: 60_000,
    retry: false,
  });
};
